import React, { useState } from 'react';
import { t } from '../../i18n';
import { DownloadIcon } from '../icons';
import { IconButton } from '../index';

export interface DataGridExportButtonProps {
  onClick: () => Promise<void> | void;
}

const DataGridExportButton: React.FC<DataGridExportButtonProps> = ({
  onClick,
}) => {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    setLoading(true);

    try {
      await onClick();
    } finally {
      setLoading(false);
    }
  };

  return (
    <IconButton
      isLoading={loading}
      variant="outline"
      aria-label="Export to CSV"
      onClick={handleClick}
      title={t('Export to CSV')}
    >
      <DownloadIcon />
    </IconButton>
  );
};

DataGridExportButton.defaultProps = {};

export default DataGridExportButton;
